import {
    createSlice,
    PayloadAction,
    ActionReducerMapBuilder,
} from '@reduxjs/toolkit';
import { RootState } from '@config/store';
import {
    ILastClosedShift,
    IRestaraunt,
    IRestTotal,
    IRevenueRestaurantsData,
    IRkeeperState,
} from '../types';
import {
    getLastClosetShift,
    getRestaurants,
    getRestTotal,
    getRevenueRestaurants,
    getRevenueWaiters,
} from '@api/thunks/rKeeper';

const initialState: IRkeeperState = {
    lastShiftClosed: null,
    revenueWaiters: null,
    selectedRestaurant: [],
    selectedRestaurantIds: [],
    revenueRestaurants: null,
    restaurants: [],
    restTotal: null,
    tableCase: 0,
    loading: 'idle',
    error: null,
};

const rKeeperSlice = createSlice({
    name: '@@rKeeper',
    initialState,
    reducers: {
        clearRkepeerState: () => {
            return initialState;
        },
        setTableCase: (
            state: IRkeeperState,
            { payload }: PayloadAction<number>
        ) => {
            state.tableCase = payload;
        },
        setSelectedRestaurant: (
            state: IRkeeperState,
            { payload }: PayloadAction<IRestaraunt[]>
        ) => {
            state.selectedRestaurant = payload;
        },
    },
    extraReducers: (builder: ActionReducerMapBuilder<IRkeeperState>) => {
        builder
            .addCase(
                getLastClosetShift.fulfilled,
                (
                    state: IRkeeperState,
                    { payload }: PayloadAction<ILastClosedShift>
                ) => {
                    state.lastShiftClosed = payload;
                }
            )
            .addCase(
                getRestaurants.fulfilled,
                (
                    state: IRkeeperState,
                    { payload }: PayloadAction<IRestaraunt[]>
                ) => {
                    state.restaurants = payload;
                    state.selectedRestaurant = [payload[0]];
                }
            )
            .addCase(
                getRestTotal.fulfilled,
                (
                    state: IRkeeperState,
                    { payload }: PayloadAction<IRestTotal>
                ) => {
                    state.restTotal = payload;
                }
            )

            .addCase(
                getRevenueWaiters.fulfilled,
                (
                    state: IRkeeperState,
                    { payload }: PayloadAction<IRevenueRestaurantsData>
                ) => {
                    state.revenueWaiters = payload;
                }
            )
            .addCase(
                getRevenueRestaurants.fulfilled,
                (
                    state: IRkeeperState,
                    { payload }: PayloadAction<IRevenueRestaurantsData>
                ) => {
                    state.revenueRestaurants = payload;
                }
            )

            .addMatcher(
                action => action.type.endsWith('/pending'),
                state => {
                    state.loading = 'loading';
                    state.error = null;
                }
            )
            .addMatcher(
                action => action.type.endsWith('/rejected'),
                (state, action: PayloadAction<string>) => {
                    state.loading = 'idle';
                    state.error = action.payload;
                }
            )
            .addMatcher(
                action => action.type.endsWith('/fulfilled'),
                state => {
                    state.loading = 'idle';
                }
            );
    },
});

export const { clearRkepeerState, setTableCase, setSelectedRestaurant } =
    rKeeperSlice.actions;
export const rKeeperReducer = rKeeperSlice.reducer;

export const rKeeperSelect = (state: RootState) => state.rKeeper;
